const DATE_REG_EXP = /^\d{4}(?:-\d{2}){2}$/;

export const getDateFromQueryString = (input: string | null) => {
  if (input === null) return undefined;
  if (!DATE_REG_EXP.test(input)) return undefined;
  return new Date(input);
};
